import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/ubuntu/vc_fullfillment/apps/web/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/vc_fullfillment/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"geist\"}");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/vc_fullfillment/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/vc_fullfillment/node_modules/leaflet/dist/leaflet.css");
